import { Notes, Image, Appear, Invert } from 'gatsby-theme-mdx-deck';
import { GitPullRequestIcon } from "@primer/octicons-react";
import selected from '@mdx-deck/themes/future';
import { vsDark as codeTheme } from "@code-surfer/themes";
import { faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { Icon } from '~utils';
import { CodeSurfer, Step, Left, Small, Color as ColorFn, Center } from '~components/DeckHelpers';
import React from 'react';
export default {
  Notes,
  Image,
  Appear,
  Invert,
  GitPullRequestIcon,
  selected,
  codeTheme,
  faGithub,
  faTwitter,
  Icon,
  CodeSurfer,
  Step,
  Left,
  Small,
  ColorFn,
  Center,
  React
};